<template>
    <div class="container">
        <div class="content">
            <div class="tabs">
                <a-tabs activeKey="1">
                    <a-tab-pane key="1" tab="机构与身份">
                        <div class="fragment">
                            <a-space :size="30" direction="vertical" style="width:100%">
                                <a-row>
                                    <a-col :span="4">当前IP</a-col>
                                    <a-col :span="9">{{currentIp?currentIp:'未知'}}</a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="4">当前IP对应机构</a-col>
                                    <a-col :span="9">
                                        <a-select style="width:300px" v-model:value="currentIpOrg" v-if="ipGroupList.length>0">
                                            <a-select-option v-for="item in ipGroupList" :key="item.collegeId" :value="item.collegeId">{{item.groupName+'-'+item.collegeName}}</a-select-option>
                                        </a-select>
                                        <span v-else>未知</span>
                                    </a-col>
                                    <a-col :span="2" v-if="ipGroupList.length>0">
                                        <a-tooltip placement="right">
                                            <setting-filled class="pointer" @click="selectCurrentOrg" />
                                            <template #title>
                                                <span>应用当前机构</span>
                                            </template>
                                        </a-tooltip>                                        
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="4">选择机构</a-col>
                                    <a-col :span="9">
                                        <a-select 
                                        show-search 
                                        style="width:300px" 
                                        v-model:value="selectedOrg"
                                        @search="handleSearch"
                                        @change="handleChange"
                                        :filterOption="(inputValue,option)=>filterOption(inputValue,option)"
                                        >                                            
                                            <template #suffixIcon><i class="iconfont icon-sousuo" style="position:relative;top:-2px;"></i></template>
                                            <a-select-option v-for="item in orgList" :key="item.groupCode" :value="item.groupCode">{{item.groupName}}</a-select-option>
                                        </a-select>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="4">所在院系</a-col>
                                    <a-col :span="9">
                                        <a-tree-select 
                                        style="width:300px" 
                                        v-model:value="selectedCollege"
                                        :tree-data="collegeList"
                                        :replaceFields="{children:'childList',title:'groupName',key:'groupId',value:'groupId'}"
                                        :dropdownStyle="{maxHeight:'300px'}"
                                        >                                            
                                            <template #suffixIcon><apartment-outlined class="ant-select-suffix" /></template>
                                        </a-tree-select>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="4">认证状态</a-col>
                                    <a-col :span="9">
                                        <span v-if="authStatus==1" class="green">认证成功 <check-circle-filled /></span>
                                        <span v-if="authStatus==0" class="red">认证失败 <close-circle-filled /></span>
                                        <span v-if="authStatus==-1" class="gray">暂未认证 <exclamation-circle-filled /></span>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="4">认证期限</a-col>
                                    <a-col :span="9" v-if="authStatus==1">
                                        <span class="red">{{time}}</span>天 
                                        <span class="red">
                                            <a-tooltip placement="bottomLeft">
                                                <question-circle-filled style="padding-left:12px;margin-left:0;" />
                                                <template #title>
                                                    <span>认证期限到期后，需要重新进行机构认证</span>
                                                </template>
                                            </a-tooltip>
                                        </span>
                                    </a-col>
                                    <a-col :span="9" v-if="authStatus==0">
                                         <span class="red">认证失败</span>
                                    </a-col>
                                    <a-col :span="9" v-if="authStatus==-1">
                                         <span class="gray">暂未认证</span>
                                    </a-col>
                                </a-row>
                            </a-space>                            
                        </div>
                        <div class="tip" v-show="!showTip&&authStatus!=1">
                            *您选择的机构与当前IP不匹配，请尽快在相应IP下完成认证。
                        </div>
                        <div class="btns">
                            <a-space :size="30" direction="horizontal" style="width:100%">
                            <a-button @click="goBack">取消</a-button>
                            <a-button type="primary" @click="goSubmit">确定</a-button>
                            </a-space>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, onMounted, reactive, toRefs } from "vue";
import {
    ApartmentOutlined,
    CloseCircleFilled,
    CheckCircleFilled,
     ExclamationCircleFilled,
    QuestionCircleFilled,
    SettingFilled
} from '@ant-design/icons-vue';
import Http from "../../until/http";
import { debounce } from "lodash-es";
import { getCookie, messageTips } from "../../until/tools";
import { useRouter } from "vue-router";
export default defineComponent({
    components:{ApartmentOutlined,CloseCircleFilled,CheckCircleFilled,QuestionCircleFilled,SettingFilled, ExclamationCircleFilled,},
    setup() {
        const state = reactive({
            authStatus:0,
            currentIp:'',
            ipGroupList:[],
            currentIpOrg:'',
            orgList:[],
            selectedOrg:undefined,
            selectedCollege:undefined,
            collegeList:[],
            time:0
        });

        const router = useRouter();

        const showTip = computed(()=>{
            let result = false;
            state.ipGroupList.some(item=>{
                if(state.selectedCollege===item.collegeId) {
                    result = true;
                    return true;
                }                
            })
            return result;
        })

        onMounted(()=>{
            let sid = getCookie('z_sid');
            if(!sid) {
                router.push('/index');
                return false;
            }
            Http.getUserInfo().then(res=>{
                if(res.userInfo) {
                    if(res.userInfo.group) {
                        console.log(res.userInfo.group.parentId);
                        Object.assign(state,{
                            orgList:[{groupCode:res.userInfo.group.parentId,groupName:res.userInfo.group.parentName}],
                            selectedOrg:res.userInfo.group.parentId
                        });
                        if(res.userInfo.group.groupCode) {
                            getColleges(res.userInfo.group.groupCode).then(()=>{
                                Object.assign(state,{                            
                                    selectedCollege:res.userInfo.group.groupId
                                });
                            })
                        }                        
                    }                    
                }
            });
            Http.getUserIsAuth().then(res=>{
                if(res.time) {
                    Object.assign(state,{
                        time:res.time
                    });
                }
                if(res.userMap) {
                    if(res.userMap.authStatus) {
                        Object.assign(state,{
                            authStatus:res.userMap.authStatus
                        })
                    }
                }
            })
            Http.getIpGroups().then(res=>{
                if(res) {
                    Object.assign(state,{
                        currentIp:res.ip,
                        ipGroupList:res.ipGroupList,
                        currentIpOrg:res.ipGroupList[0]?res.ipGroupList[0].collegeId:undefined
                    });
                }
            })
        });

        const selectCurrentOrg = ()=>{
            state.ipGroupList.some((item)=>{
                if(item.collegeId===state.currentIpOrg) {
                    Object.assign(state,{
                        orgList:[{groupCode:item.groupCode,groupName:item.groupName}],
                        selectedOrg:item.groupCode,
                    });
                    getColleges(item.groupCode).then(()=>{
                        Object.assign(state,{                            
                            selectedCollege:item.collegeId
                        });
                    });
                    return true;
                }                
            });
        }

        const fetch = debounce((value) => {
            Http.searchOrg({ groupName: value }).then((res) => {
                if (res.list) {
                    Object.assign(state, {
                        orgList: res.list,
                    });
                }
            });
        }, 300);


        const handleSearch = val => {
            if(val.length<2) {
                return false;
            }
            if(val==='大学'||val==='学院'||val==='学校') {
                return false;
            }
            fetch(val);
        };

        const handleChange = val => {
            Object.assign(state,{
                selectedCollege:undefined
            });
            getColleges(val);
        };

        const getColleges = val => {
            return Http.getOrgChildren({type:1,isPerfect:1,groupCode:val}).then(res=>{
                if(res.groupList&&res.groupList[0]) {
                    if(res.groupList[0].parentId==='00') {
                        let tsg = {groupCode:res.groupList[0].groupCode,groupName:'图书馆',groupId: res.groupList[0].groupId}
                        Object.assign(state,{
                            collegeList:[tsg,...res.groupList[0].childList]
                        });
                    }
                }   
                return res;             
            })
        }

        const filterOption = (inputvalue,option) => {
            let name = option.children[0].children;
            if(name.indexOf(inputvalue)===-1) {
                return false;
            } else {
                return true;
            }
        }

        const goSubmit = ()=>{
            if(!state.selectedCollege) {
                messageTips('请选择所在院系',2);
                return false;
            }
            Http.goPerfectOrg({collegeId:state.selectedCollege}).then(res=>{
                if(res.success) {
                    messageTips(res.message,3);
                    window.location.reload();
                }else {
                    messageTips(res.message,1);
                } 
            })
        }

        const goBack = ()=>{
            router.go(-1);
        }

        return {
            ...toRefs(state),
            selectCurrentOrg,
            handleSearch,
            handleChange,
            filterOption,
            showTip,
            goSubmit,
            goBack
        }
    }
});
</script>

<style lang="scss" scoped>
@import '~@/scss/_variables.scss';
.container {
    .content {
        width: 1000px;
        margin: 0 auto;
        padding: 12px 0;
        .tabs {
            background: #fff;
            padding: 12px 20px;
            min-height: calc(100vh - 140px);
            .fragment{
                width: 800px;
                margin: 0 auto;
                padding-top:40px;
                line-height: 40px;
                .red {
                    color:#F5242E;
                }
                .green {
                    color:#52c41a;
                }
                .gray{
                    color: #c6c6c6;
                }
                .anticon {
                    margin-left:5px;
                    position: relative;
                    top:1px;
                }
                .pointer {
                    cursor:pointer;
                    color:$primary-color;
                }
            }
        }
        .tip {
            padding-left: 220px;
            color:$primary-color;
            line-height: 32px;
        }
        .btns {
            margin-top: 100px;
            text-align: center;
            padding-left: 220px;
        }
    }
}
</style>